module.exports = __webpack_public_path__ + "img/settings-icon.0afbf5f8.svg";